module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-500.49e8040.otf";